import { IOptionProps } from "@blueprintjs/core";
import { useRequest } from "ahooks";
import React from "react";
import { ReferentialApi, ReferentialItemDto } from "../api";
import { useApiService } from "./useApiService";

function convertToOptionProp(data: ReferentialItemDto[], asInt = true) {
  return data?.map((p) => {
    return { value: p.idValue ? (asInt ? +p.idValue : p.idValue) : null, label: p.displayValue };
  }) as IOptionProps[];
}

export function useReferentials() {
  const api = useApiService(ReferentialApi);

  const {
    loading: loadingBelgianLocality,
    run: refreshBelgianLocality,
    data: belgianLocalities,
  } = useRequest(api.getStringifiedBelgianLocalityFromPostalCode, {
    manual: false,
  });

  return {
    belgianLocality: React.useMemo(
      () => ({
        loading: loadingBelgianLocality,
        refresh: refreshBelgianLocality,
        data: convertToOptionProp(belgianLocalities, false),
      }),
      [belgianLocalities, loadingBelgianLocality, refreshBelgianLocality]
    ),
  };
}
